export default class StoryVariables { }

StoryVariables.WEEK_NUMBER = "week_number";